export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11570.4a9bf918.jpg";